// External libraries
import { css } from '@emotion/core';

// Internal modules
import { DEFAULT_BORDER_COLOR, PRIMARY_COLOR, WHITE_COLOR } from '@/styles';

const appStoreButtonStyles = css`
  align-items: center;
  background-color: ${WHITE_COLOR};
  border-color: ${PRIMARY_COLOR};
  border-style: solid;
  border-width: 0.0625rem;
  color: ${PRIMARY_COLOR};
  display: flex;
  justify-content: center;

  svg,
  img {
    height: 50%;
    max-width: 2em;
    padding-right: 0.5em;
  }

  &:active,
  &:focus,
  &:hover {
    background-color: ${WHITE_COLOR};
    text-decoration: underline;
  }
`;

const interstitialOverlayStyles = css`
  bottom: 0;
  top: unset;
  z-index: 1000;

  @media (min-width: 700px) {
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getInterstitialStyles = (cookieBannerOffset = 0) => css`
  align-items: center;
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  height: auto;
  padding: 1.5em 1.125em;
  text-align: center;
  width: auto;

  h3 {
    line-height: 1.5;
    padding-bottom: 1.5em;
  }

  button:first-of-type {
    align-items: center;
    display: flex;
    justify-content: center;
    text-align: center;
    text-decoration: none;

    &:active,
    &:focus,
    &:hover {
      text-decoration: underline;
    }

    svg,
    img {
      height: 50%;
      max-width: 7em;
      padding: 0 0.5em;
      width: auto;
    }
  }

  @media (max-width: 699px) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    bottom: 0;
    position: absolute;
    top: unset;
    width: 100vw;

    .ccpaCookieBanner-acceptedAll &,
    .gdprCookieBanner-acceptedAll & {
      padding-bottom: calc(${cookieBannerOffset}px + 1.5em);
    }
  }
`;

const horizontalRuleStyling = css`
  display: flex;
  justify-content: center;
  margin: 1.125em 0;
  position: relative;
  width: 100%;

  &::before {
    background-color: ${DEFAULT_BORDER_COLOR};
    content: '';
    display: block;
    height: 1px;
    position: absolute;
    top: 50%;
    width: 100%;
    z-index: 1;
  }

  span {
    background-color: ${WHITE_COLOR};
    padding: 0 1em;
    position: relative;
    z-index: 2;
  }
`;

export {
  appStoreButtonStyles,
  getInterstitialStyles,
  horizontalRuleStyling,
  interstitialOverlayStyles,
};
